import React from 'react';
import { CheckIcon } from 'lucide-react';
interface FeaturePointProps {
  children: React.ReactNode;
}
const FeaturePointGlpAdv3 = ({
  children
}: FeaturePointProps) => {
  return <div className="flex items-start" data-id="element-16946">
      <div className="flex-shrink-0 mt-1" data-id="element-16947">
        <CheckIcon className="h-5 w-5 text-green-600" data-id="element-16948" />
      </div>
      <div className="ml-2 text-base text-green-600" data-id="element-16949">{children}</div>
    </div>;
};
export default FeaturePointGlpAdv3;